import { uniqueId } from 'lodash'

import { API__MEDIA } from '../../api'
import { ASSET_TABS, SIZE_IMAGES, SORT_TABS, UPLOAD_STATUS } from '../../common/components/AssetManager/utils/constants'
import { concatImageLists, mapUnsplashImages } from '../../common/components/AssetManager/utils/utils.js'
import Toast from '../../common/components/Toast/Toast'

export const ASSET_MANAGER__SET_PROJECT_ID = projectId => ({
    type: 'ASSET_MANAGER__SET_PROJECT_ID',
    payload: {
        projectId,
    },
})

export const ASSET_MANAGER__MANAGER_SET_TAB = tab => ({
    type: 'ASSET_MANAGER__MANAGER_SET_TAB',
    payload: {
        tab,
    },
})

export const ASSET_MANAGER__LIBRARY__SET_TAB = tab => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_TAB',
    payload: {
        tab,
    },
})

export const ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID = id => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID',
    payload: {
        id,
    },
})

export const ASSET_MANAGER__LIBRARY__DEL_IF_EQUALS_SELECTED_IMAGE_ID = id => (dispatch, getState) => {
    const selectedImageId = getState().assetManager.library.selectedImageId

    if (id === selectedImageId) {
        dispatch(ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID(null))
    }
}

export const ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES = isLoadImages => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES',
    payload: {
        isLoadImages,
    },
})

export const ASSET_MANAGER__LIBRARY__SET_IS_LOAD_ERROR = isLoadError => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_IS_LOAD_ERROR',
    payload: {
        isLoadError,
    },
})

export const ASSET_MANAGER__LIBRARY__RESET_LIBRARY = () => ({
    type: 'ASSET_MANAGER__LIBRARY__RESET_LIBRARY',
    payload: {},
})

export const ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE = () => ({
    type: 'ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE',
    payload: {},
})

export const ASSET_MANAGER__LIBRARY__SET_IMAGES = images => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_IMAGES',
    payload: {
        images,
    },
})

export const ASSET_MANAGER__LIBRARY__SET_SEARCH = search => ({
    type: 'ASSET_MANAGER__LIBRARY__SET_SEARCH',
    payload: {
        search,
    },
})

// MY LIBRARY

export const ASSET_MANAGER__MY_LIBRARY__SET_TAB = tab => async dispatch => {
    await dispatch(ASSET_MANAGER__LIBRARY__RESET_LIBRARY())

    await dispatch(ASSET_MANAGER__LIBRARY__SET_TAB(tab))

    dispatch(
        ASSET_MANAGER__MY_LIBRARY__LOAD_IMAGES(images => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IMAGES(images))
        }),
    )
}

export const ASSET_MANAGER__MY_LIBRARY__UP_IMAGES_PAGE = () => async (dispatch, getState) => {
    const { content, last } = getState().assetManager.library.images

    if (!last) {
        await dispatch(ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE())

        dispatch(
            ASSET_MANAGER__MY_LIBRARY__LOAD_IMAGES(images => {
                dispatch(ASSET_MANAGER__LIBRARY__SET_IMAGES({ ...images, content: [...content, ...images.content] }))
            }),
        )
    }
}

export const ASSET_MANAGER__MY_LIBRARY__LOAD_IMAGES = callback => async (dispatch, getState) => {
    const {
        assetManager: { projectId, library },
    } = getState()
    const {
        pageable: { pageSize, pageNumber },
    } = library.images

    const pageSizeWithOffset = pageSize + library.offset

    const _projectId = library.tab === SORT_TABS.SORT_TAB_THIS_PROJECT ? projectId : void 0
    dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES(true))

    Promise.all([
        API__MEDIA.GET_IMAGES(pageSizeWithOffset, pageNumber, SIZE_IMAGES.SMALL, _projectId),
        API__MEDIA.GET_IMAGES(pageSizeWithOffset, pageNumber, SIZE_IMAGES.NORMAL, _projectId),
    ])
        .then(([images, normalImages]) => {
            const concatImages = concatImageLists(images, normalImages)
            callback(concatImages)
        })
        .catch(error => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_ERROR(true))
            Toast('error', error)
        })
        .finally(() => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES(false))
        })
}

export const ASSET_MANAGER__MY_LIBRARY__UPLOAD_IMAGE = (fileName, contentType, bytes) => async (dispatch, getState) => {
    const { projectId, managerTab } = getState().assetManager

    const response = await API__MEDIA.UPLOAD_IMAGE(projectId, fileName, contentType, await bytes)

    const image = response.imageSizes.reduce((acc, item) => {
        if (item.imageSize === SIZE_IMAGES.SMALL) {
            acc = { ...acc, ...item }
        } else if (item.imageSize === SIZE_IMAGES.NORMAL) {
            acc = {
                ...acc,
                normalUrl: item.url,
            }
        }
        return acc
    }, {})

    image.originalImageId = response.id

    if (managerTab === ASSET_TABS.TAB_MY_LIBRARY) {
        dispatch({
            type: 'ASSET_MANAGER__MY_LIBRARY__UPLOAD_IMAGE',
            payload: {
                image,
            },
        })
    } else {
        dispatch(ASSET_MANAGER__MANAGER_SET_TAB(ASSET_TABS.TAB_MY_LIBRARY))
    }
}

export const ASSET_MANAGER__MY_LIBRARY__DELETE_IMAGE = id => async dispatch => {
    await API__MEDIA.DELETE_IMAGE(id)

    dispatch(ASSET_MANAGER__LIBRARY__DEL_IF_EQUALS_SELECTED_IMAGE_ID(id))

    dispatch({
        type: 'ASSET_MANAGER__MY_LIBRARY__DELETE_IMAGE',
        payload: {
            id,
        },
    })
}

// UNSPLASH LIBRARY

export const ASSET_MANAGER__UNSPLASH_LIBRARY__INIT = () => async dispatch => {
    await dispatch(ASSET_MANAGER__LIBRARY__RESET_LIBRARY())
    await dispatch(ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE())

    dispatch(
        ASSET_MANAGER__UNSPLASH_LIBRARY__LOAD_IMAGES(images => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IMAGES(images))
        }),
    )
}

export const ASSET_MANAGER__UNSPLASH_LIBRARY__UP_IMAGES_PAGE = () => async (dispatch, getState) => {
    const { content, last } = getState().assetManager.library.images

    if (!last) {
        await dispatch(ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE())

        dispatch(
            ASSET_MANAGER__UNSPLASH_LIBRARY__LOAD_IMAGES(images => {
                dispatch(ASSET_MANAGER__LIBRARY__SET_IMAGES({ ...images, content: [...content, ...images.content] }))
            }),
        )
    }
}

export const ASSET_MANAGER__UNSPLASH_LIBRARY__SEARCH = search => async dispatch => {
    await dispatch(ASSET_MANAGER__LIBRARY__RESET_LIBRARY())
    await dispatch(ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE())
    await dispatch(ASSET_MANAGER__LIBRARY__SET_SEARCH(search))
    dispatch(
        ASSET_MANAGER__UNSPLASH_LIBRARY__LOAD_IMAGES(images => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IMAGES(images))
        }),
    )
}

export const ASSET_MANAGER__UNSPLASH_LIBRARY__LOAD_IMAGES = callback => async (dispatch, getState) => {
    const {
        assetManager: { library },
    } = getState()
    const {
        pageable: { pageSize, pageNumber },
    } = library.images

    dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES(true))

    API__MEDIA.GET_UNSPLASH_IMAGES(pageSize, pageNumber, library.search)
        .then(response => {
            const mappedImages = mapUnsplashImages(response)
            callback(mappedImages)
        })
        .catch(error => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_ERROR(true))
            Toast('error', error)
        })
        .finally(() => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES(false))
        })
}

export const ASSET_MANAGER__UNSPLASH_LIBRARY__SAVE_IMAGE = () => async (dispatch, getState) => {
    const {
        assetManager: { library, projectId },
    } = getState()

    const { selectedImageId } = library

    API__MEDIA.SAVE_UNSPLASH_IMAGE(selectedImageId, projectId, selectedImageId)
        .catch(error => {
            Toast('error', error)
        })
        .finally(() => {
            dispatch(ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES(false))
        })
}

// UPLOAD MEDIA

export const ASSET_MANAGER__DEL_UPLOAD_MEDIA_INFO = id => ({
    type: 'ASSET_MANAGER__DEL_UPLOAD_MEDIA_INFO',
    payload: {
        id,
    },
})

export const ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO = (id, info) => ({
    type: 'ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO',
    payload: {
        id,
        info,
    },
})

export const ASSET_MANAGER__ADD_UPLOAD_MEDIA_INFO = info => async dispatch => {
    const id = uniqueId()
    dispatch(ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO(id, info))
    await new Promise(resolve => setTimeout(resolve, 15000))
    dispatch(ASSET_MANAGER__DEL_UPLOAD_MEDIA_INFO(id))
}

export const ASSET_MANAGER__ADD_UPLOAD_MEDIA = file => dispatch => {
    const id = uniqueId()
    const reader = new FileReader()

    reader.addEventListener('loadstart', ev =>
        dispatch(
            ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO(id, {
                total: ev.total,
                name: file.name,
                status: UPLOAD_STATUS.prepare,
            }),
        ),
    )

    reader.addEventListener('load', async ev => {
        try {
            await dispatch(ASSET_MANAGER__MY_LIBRARY__UPLOAD_IMAGE(file.name, file.type, reader.result))

            dispatch(
                ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO(id, {
                    total: ev.total,
                    name: file.name,
                    status: UPLOAD_STATUS.ok,
                }),
            )

            await new Promise(resolve => setTimeout(resolve, 3000))
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                dispatch(
                    ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO(id, {
                        total: ev.total,
                        name: file.name,
                        status: 'error',
                        message: err.response.data.message,
                    }),
                )
            }

            await new Promise(resolve => setTimeout(resolve, 15000))
        } finally {
            dispatch(ASSET_MANAGER__DEL_UPLOAD_MEDIA_INFO(id))
        }
    })

    reader.addEventListener('error', ev => {
        dispatch(
            ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO(id, {
                total: ev.total || 0,
                name: file.name,
                status: UPLOAD_STATUS.error,
            }),
        )
    })

    reader.readAsArrayBuffer(file)
}
